import { useSelector } from 'react-redux';

export const usePaddle = (override = null) => {
  const user = useSelector(({ User }) => User.data);
  const reduxOverride = useSelector(({ PaymentProvider }) => PaymentProvider.override);

  // Use the provided override if it exists, otherwise use the Redux override
  const effectiveOverride = override !== null ? override : reduxOverride;

  console.log('usePaddle', {
    override: effectiveOverride,
    paddle_id: user?.paddle_id,
    stripe_id: user?.stripe_id,
  });

  // 1. If override is provided, use that value
  if (effectiveOverride !== null) {
    return effectiveOverride;
  }

  // 2. If user has a paddle_id, always use Paddle
  if (user?.paddle_id) {
    return true;
  }

  // 3. If user has a stripe_id but no paddle_id, use Stripe
  if (user?.stripe_id && !user?.paddle_id) {
    return false;
  }

  // 4. Otherwise, use Paddle
  return true;
};

export default usePaddle;
